export default __webpack_public_path__ + "static/media/common.a48d3c22.gif";